module.exports = __webpack_public_path__ + "static/media/nft-start-img1.e8461ea3.svg";